import _axios from '@/assets/utils/_axios'
import Router from '@/router'
import {_loading} from '../../assets/utils/utils'
import HotLetterCity from '@/assets/utils/HotLetterCity.json'             //城市信息
import { data } from 'jquery';

export default {
    //首页模糊搜索
    async POST_SearchDocHotel ({ commit, getters,dispatch }, {data,adminsearch}) {
        let url = ''
        //旅行社-酒店-搜索
        console.log(adminsearch)
        if(adminsearch){
            url=data.storeType==2?'/pc/Admin/SearchDocTravel':'/pc/Admin/SearchDocHotel'
        }else{
            url=data.storeType==2?'/pc/Elasticsearch/SearchDocTravel':'/pc/Elasticsearch/SearchDocHotel'
        }
        let res = await _axios.post(url, {...data});
        if (res.code === '00000'){
            console.log(res)
            if(res.other){
                let newArr = res.other.list.filter(item => item.city != data.city).map(item => ({ ...item, flag: true }));
                console.log(newArr)
                res.data.list=[...res.data.list,...newArr]
            }
            return res.data;
        }
    },
    //首页热门城市
    async POST_GetAllCity ({ commit, getters,dispatch }, {data}) {
        return HotLetterCity;  
        let res = await _axios.post('/pc/Visitor/getAllCity', {...data});
        if (res.code === '00000'){
            
        }
    },
    //首页酒店列表
    async POST_HotelList({ commit, getters,dispatch }, {data}) {
        let res = await _axios.post('/pc/Home/HotelList', {...data});
        if (res.code === '00000'){
            return res;
        }
    },
    //获取城市名称
    async POST_GetCityName({commit, getters},{data}) {
        let res = await _axios.post('/pc/Visitor/GetCityName', {...data});
        if (res.code === '00000'){
            //合并城市筛选
            const allList = Object.values(HotLetterCity.info).flat();
            //查找城市ID值
            const item = allList.find(i => i.title === res.data.info);
            return item;
        }
    },
}